
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $e93rA = parcelRequire("e93rA");
const $0f6442246e692292$var$canvas = document.querySelector("#mainCanvas");
const $0f6442246e692292$var$ctx = $0f6442246e692292$var$canvas.getContext("2d");
const $0f6442246e692292$var$dpr = window.devicePixelRatio;
const $0f6442246e692292$var$cw = window.innerWidth;
const $0f6442246e692292$var$ch = window.innerHeight;
$0f6442246e692292$var$canvas.width = $0f6442246e692292$var$cw * $0f6442246e692292$var$dpr;
$0f6442246e692292$var$canvas.height = $0f6442246e692292$var$ch * $0f6442246e692292$var$dpr;
$0f6442246e692292$var$ctx.scale($0f6442246e692292$var$dpr, $0f6442246e692292$var$dpr);
function $0f6442246e692292$var$random(min, max) {
    return min + Math.random() * (max - min);
}
function $0f6442246e692292$var$resize() {
    $0f6442246e692292$var$canvas.width = window.innerWidth * $0f6442246e692292$var$dpr;
    $0f6442246e692292$var$canvas.height = window.innerHeight * $0f6442246e692292$var$dpr;
}
window.addEventListener('resize', $0f6442246e692292$var$resize, false);
class $0f6442246e692292$var$Star {
    // Star x and y are offsets from center of screen
    constructor(x, y, multiplier){
        this.x = x;
        this.y = y;
        this.multiplier = multiplier;
        this.color = $0f6442246e692292$var$random(0, 360);
    }
    canvasPos() {
        return {
            x: $0f6442246e692292$var$canvas.width / 2 + this.x,
            y: $0f6442246e692292$var$canvas.height / 2 + this.y
        };
    }
    size() {
        // Size is proportional to distance from the middle
        //const dist = Math.max(this.x, this.y);
        //return Math.max(1.5, dist/100);
        return 1.0;
    }
    render(ctx, style) {
        const { x: x, y: y } = this.canvasPos();
        const r = this.size();
        ctx.fillStyle = this.computeStyle(style);
        ctx.beginPath();
        ctx.arc(x, y, r, 0, 2 * Math.PI);
        ctx.fill();
    }
    computeStyle(style) {
        if (style == "white") return "white";
        if (style == "red") return "red";
        if (style == "multi") return `hsl(${this.color}, 100%, 50%)`;
    }
    static make() {
        const angle = Math.random() * 2 * Math.PI;
        const x = Math.cos(angle);
        const y = Math.sin(angle);
        // The multiplier affects how quickly the star moves.
        // Varying this makes some stars appear closer (faster
        // movement), some further (slower movement).
        const multiplier = 1.01 + Math.random() * 0.04;
        return new $0f6442246e692292$var$Star(x, y, multiplier);
    }
}
const $0f6442246e692292$var$state = {
    start: null,
    stars: [],
    timeSinceLastStar: Infinity
};
const $0f6442246e692292$var$options = {
    fadeout: 0.08,
    starIntervalMS: 2000,
    starStyle: "white"
};
const $0f6442246e692292$var$controls = new $e93rA.GUI({
    name: "Controls",
    closed: false
});
$0f6442246e692292$var$controls.add($0f6442246e692292$var$options, "fadeout").min(0).max(1).step(0.01).name("Fadeout");
$0f6442246e692292$var$controls.add($0f6442246e692292$var$options, "starIntervalMS").min(500).max(50000).step(500).name("Star Interval");
$0f6442246e692292$var$controls.add($0f6442246e692292$var$options, "starStyle").options({
    "White": "white",
    "Red": "red",
    "Multi": "multi"
}).name("Style");
function $0f6442246e692292$var$clear(ctx, alpha) {
    ctx.globalCompositeOperation = "destination-out";
    ctx.fillStyle = `rgba(0,0,0, ${alpha})`;
    ctx.fillRect(0, 0, $0f6442246e692292$var$canvas.width, $0f6442246e692292$var$canvas.height);
    ctx.globalCompositeOperation = "lighter";
}
function $0f6442246e692292$var$loop(timestamp) {
    if ($0f6442246e692292$var$state.start === null) $0f6442246e692292$var$state.start = timestamp;
    const progress = timestamp - $0f6442246e692292$var$state.start;
    // Create a new star if it's been long enough since
    // the previous one
    $0f6442246e692292$var$state.timeSinceLastStar += progress;
    if ($0f6442246e692292$var$state.timeSinceLastStar > $0f6442246e692292$var$options.starIntervalMS) {
        $0f6442246e692292$var$state.timeSinceLastStar = 0;
        $0f6442246e692292$var$state.stars.push($0f6442246e692292$var$Star.make());
    }
    // Clear the screen.
    // If you want the hyperspace effect, skip this.
    $0f6442246e692292$var$clear($0f6442246e692292$var$ctx, $0f6442246e692292$var$options.fadeout);
    $0f6442246e692292$var$state.stars.forEach((star)=>{
        // Increase the star's distance from the middle
        // proportionally to its current distance
        const multiplier = star.multiplier;
        star.x *= multiplier;
        star.y *= multiplier;
        star.render($0f6442246e692292$var$ctx, $0f6442246e692292$var$options.starStyle);
    });
    // Remove stars outside the view boundary
    let i = $0f6442246e692292$var$state.stars.length;
    while(--i){
        const star = $0f6442246e692292$var$state.stars[i];
        let { x: x, y: y } = star.canvasPos();
        if (x < 0 || x > $0f6442246e692292$var$canvas.width || y < 0 || y > $0f6442246e692292$var$canvas.height) $0f6442246e692292$var$state.stars.splice(i, 1);
    }
    window.requestAnimationFrame($0f6442246e692292$var$loop);
}
window.requestAnimationFrame($0f6442246e692292$var$loop) //reference(canvas, ctx);
;


//# sourceMappingURL=index.aaec107b.js.map
